const automation = {
  onboardingModal: {
    title: 'Primeiro acesso',
    welcomeStep: {
      title: 'Boas-vindas ao Automação Clicksign!',
      content: [
        'Você está começando uma nova jornada que vai transformar seus envios e assinaturas.',
        'Confira nesse e nos próximos vídeos o que Michael Bernstein, Founder & CRO da Clicksign, tem a dizer sobre o Automação e as possibilidades para o seu negócio.',
        'Aproveite essa oportunidade para otimizar seus processos e economizar tempo, gerenciando documentos de forma simplificada e estratégica.',
      ],
      action: 'Começar',
    },
    templateStep: {
      title: 'Modelos: tudo o que você precisa saber.',
      content: [
        'O modelo da Clicksign é uma forma prática e inteligente de criar documentos personalizados sem precisar editar um por um. Ele permite gerar os documentos automaticamente para assinatura, tornando a gestão muito mais simples.',
        'Assista o vídeo e saiba mais.',
      ],
    },
    formFlowStep: {
      title: 'Fluxos com formulário: gere contratos com agilidade.',
      content: [
        'Aprenda como utilizar o fluxo com formulário e simplifique sua rotina de negócios ao gerar documentos personalizados e preenchidos automaticamente com os dados dos seus usuários.',
        'Assista o vídeo e saiba mais.',
      ],
    },
    spreadsheetFlowStep: {
      title: 'Fluxos com planilha: escalabilidade para seus documentos.',
      content: [
        'Esse fluxo é feito para quem já tem as informações dos usuários organizadas em planilhas, que funcionam como base de dados para a geração automática dos documentos. É a opção ideal para enviar múltiplos documentos para assinatura com agilidade e segurança.',
        'Assista o vídeo e saiba mais.',
      ],
    },
    startAutomationStep: {
      title: 'Parabéns! Você concluiu a sua jornada pelo guia.',
      description: 'Selecione uma das funcionalidades abaixo e comece sua jornada na prática:',
      templateOption: 'Criar modelo',
      formFlowOption: 'Criar fluxo com formulário',
      spreadsheetFlowOption: 'Criar fluxo com planilha',
      action: 'Começar',
      helpButtonReminder:
        'Caso você ainda tenha dúvidas ou precise consultar o guia novamente, basta clicar no botão de Ajuda.',
      conclusion: 'Conte com a Clicksign nessa jornada.',
    },
    alert: 'Consulte o guia de Primeiro acesso quando quiser, clicando no botão de Ajuda.',
  },
};

export default automation;
